import { render, staticRenderFns } from "./PcIdxNum3MTable.vue?vue&type=template&id=199cf413&"
import script from "./PcIdxNum3MTable.vue?vue&type=script&lang=js&"
export * from "./PcIdxNum3MTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports